import React, { useState } from 'react';
import useScrollScale from '../hooks/useScrollScale';
import '../App.css';
import Header from './Header';
import zubayr from '../assets/profile_pics/zb.jpg';
import eesha from '../assets/profile_pics/es.jpg';
import david from '../assets/profile_pics/dvd.jpg';
import diyona from '../assets/profile_pics/dy.jpg';
import issy from '../assets/profile_pics/iz.jpg';

function ForCandidates() {
    const scale = useScrollScale();
    const [billingCycle, setBillingCycle] = useState('monthly');

    const toggleBillingCycle = (cycle) => {
        setBillingCycle(cycle);
    };

    // Sample candidate data
    const candidates = [
        {
            id: 1,
            initials: 'Zubayr Ghufoor',
            experience: 6,
            description: "Led Anduril's software platform development with deployment in active war zones.",
            expertise: ['Python', 'Pytorch', 'Docker', 'C++', 'SQL'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 94,
            image: zubayr
        },
        {
            id: 2,
            initials: 'Eesha Sondhi',
            experience: 22,
            description: "Led $600M bid for major broadband project; senior roles at Microsoft, Deloitte.",
            expertise: ['Strategic Planning', 'Project Management', 'Financial Analysis'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 87,
            image: eesha
        },
        {
            id: 5,
            initials: 'David Chen',
            experience: 10,
            description: "Developed AI and ML technologies at Apple, Intel, and MathWorks.",
            expertise: ['Python', 'C++', 'Objective-C'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 85,
            image: david
        },
        {
            id: 6,
            initials: 'Diyona Dsouza',
            experience: 17,
            description: "Led GE Healthcare as Chief Medical Officer, enhancing molecular imaging innovations.",
            expertise: ['Medical Writing', 'Regulatory Compliance', 'Strategic Planning'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 83,
            image: diyona
        },
        {
            id: 7,
            initials: 'Issobel Dipple',
            experience: 12,
            description: "Former product lead at Google, specialized in AI-driven user experiences.",
            expertise: ['Product Management', 'UX Design', 'AI Integration'],
            commitment: 'Part-time',
            partTime: true,
            operationalFit: 89,
            image: issy
        }
    ];

    return (
        <div className="pricing-page">
            <Header />
            
            <div className="pricing-container">
                    <div className="candidate-dashboard" style={{marginTop: '50px', marginBottom: '-50px'}}>
                        <div className="candidate-hero">
                            <div className="candidate-hero-content">
                                <h2>Find the company <br/>that <span className="highlight">suits you best </span><br/>with Quokka.</h2>
                                <p style={{fontWeight: '200', marginTop: '-10px'}}>Join the companies that fit your needs and preferences.</p>
                            </div>
                            <div className="candidate-card">
                                <div className="card-icon">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                        <polyline points="14 2 14 8 20 8"></polyline>
                                        <line x1="16" y1="13" x2="8" y2="13"></line>
                                        <line x1="16" y1="17" x2="8" y2="17"></line>
                                        <polyline points="10 9 9 9 8 9"></polyline>
                                    </svg>
                                </div>
                                <h3>Get started</h3>
                                <p>Get considered for hundreds of opportunities with one application</p>
                                <button 
                                    className="upload-resume-button"
                                    onClick={() => window.open('https://meetings.hubspot.com/david4497', '_blank')}
                                >
                                    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                        <polyline points="17 8 12 3 7 8"></polyline>
                                        <line x1="12" y1="3" x2="12" y2="15"></line>
                                    </svg>
                                    Upload resume
                                </button>
                            </div>
                        </div>
                        
                        <div className="application-steps">
                            <div className="step">
                                <div className="step-number">1</div>
                                <h4>Complete Profile</h4>
                                <p>2 mins</p>
                            </div>
                            <div className="step">
                                <div className="step-number">2</div>
                                <h4>Take Assessment</h4>
                                <p>20 mins</p>
                            </div>
                            <div className="step">
                                <div className="step-number">3</div>
                                <h4>Get Matches</h4>
                                <p>Ongoing</p>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    );
}

export default ForCandidates;
